import {
  FormResultRepresentantDelegataire,
} from '@common/schemas/src/forms/organisme/representant/delegate-representative-form.schema';
import { UtilisateurRepresentantDelegataireDto } from '@common/services/utilisateur';
import { SavedFile } from '@common/ui';

export function mapEditRlFormResult(result: FormResultRepresentantDelegataire):
  {
    representant: UtilisateurRepresentantDelegataireDto,
    delegataire?: UtilisateurRepresentantDelegataireDto,
    legalFile: SavedFile,
    delegateFile: SavedFile
  } {
  const {
    lastName,
    firstName,
    job,
    phone,
    email,
    legalFile,
    delegateLastName,
    delegateFirstName,
    delegateEmail,
    delegateJob,
    delegateFile,
  } = result;

  const representant: UtilisateurRepresentantDelegataireDto = {
    nom: lastName,
    prenom: firstName,
    email: email,
    travail: job,
    telephone: phone,
  };

  const delegataire: UtilisateurRepresentantDelegataireDto | undefined =
    delegateLastName ? {
      nom: delegateLastName,
      prenom: delegateFirstName,
      email: delegateEmail,
      travail: delegateJob,
      telephone: phone,
    } : undefined;

  return { representant, delegataire, legalFile, delegateFile };
}